import { gql } from '@apollo/client';

export const ANALYSIS_FIELDS = gql`
  fragment AnalysisFields on Analysis {
    analysis_id
    race {
      race_id
    }
    horse_id
    horse_name
    odds
    assessed_odds
    confidence
    analysis_summary
    pros
    cons
    pick_order
    pick_type
    adjusted_assessed_prob
  }
`;
